import { $apiNews } from '../global';

export const getAllArticles =
  ({
    page,
    languageId,
    categoryId,
    size = 10
  }: {
    page?: string | string[];
    languageId?: number;
    categoryId?: string | string[] | undefined;
    size?: number;
  }) =>
  async () => {
    const { data } = await $apiNews.get('/article/view', {
      params: { page, category_id: categoryId, language_id: languageId, size }
    });

    return { news: data };
  };

export const getAllNewsCategory = (languageId?: number) => async () => {
  const { data } = await $apiNews.get('/api/category/view', {
    params: { language_id: languageId }
  });

  return data;
};

export const getNewsBySlug = (slug?: string) => async () => {
  const { data } = await $apiNews.get('/article/view', {
    params: { slug }
  });

  return data?.data;
};

export const getRecommendedNews = (slug?: string) => async () => {
  const { data } = await $apiNews.get('/article/related', {
    params: { slug }
  });

  return data;
};
